import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';

const { RangePicker } = DatePicker;

const RangePickerSystem = ({ theme = 'light', ...props }) => (
  <RangePicker
    {...props}
    className={`rangepicker-input-design-system theme--${theme}`}
    dropdownClassName={`rangepicker-design-system theme--${theme} ${props.onTop && 'on-top'}`}
  />
);

RangePickerSystem.propTypes = {
  theme: PropTypes.oneOf(['light', 'dark']),
  onTop: PropTypes.bool
};

export default RangePickerSystem;
